<template>
	<div :style="this.showicon == true ? '':'margin-top:-110px' ">
		<logo v-if="showLogo" />
		<div style="position: relative;">
			<div style="width: 200px; height: 53px; position: absolute; left: 18px; top: 13px;" class="logo_mini_box" v-show="!showicon">
				<img src="../../../assets/image/logo_small.png" style="width:100%;height:100%;">
			</div>
			<el-menu :background-color="variables.menuBg" :text-color="variables.menuText" :unique-opened="true"
			 :active-text-color="settings.theme" :collapse-transition="false" mode="vertical" class="top_nav" :default-active="activeMenu">
				<!--:default-active="activeMenu"-->
				<!-- <el-scrollbar wrap-class="scrollbar-wrapper" class="top_scroll"> -->
				<!--swiper-no-swiping 为禁止拖动导航-->
				<div class="swiper-container swiper-no-swiping" ref="width_page" style="margin-right:29px;">
					<div class="swiper-wrapper" style="width: auto;" ref="width">
						<sidebar-item class="swiper-slide" v-for="(route, index) in sidebarRouters" :key="route.path + index" :item="route"
						 :index="index" :base-path="route.path" />
					</div>
				</div>
				<div class="swiper-button-next swiper-button-white" style="right:0px;top:43px;" v-show="this.navwidth >= this.navwidth_page"></div>
				{{this.navwidth}}
				{{this.navwidth_page}}
				<!-- </el-scrollbar> -->
			</el-menu>
			<div class="swiper-button-prev swiper-button-white" style="left: 236px;top: 43px;" v-show="this.navwidth >= this.navwidth_page"></div>
			<!-- <div class="swiper-container">
			    <div class="swiper-wrapper">
			      <div class="swiper-slide">Slide 1</div>
			      <div class="swiper-slide">Slide 2</div>
			      <div class="swiper-slide">Slide 3</div>
			    </div>
			    <!-- 如果需要分页器 -->
			<!-- <div class="swiper-pagination"></div> -->
			<!-- 如果需要滚动条 -->
			<!--    <div class="swiper-scrollbar"></div>-->
			<div class="topRightOut">
				<navbar class="topnavbar" />
        <svg-icon :icon-class=" this.showicon == true ? 'showlogo' : 'showlogo_active' " class="showlogo" v-on:click="logo_sh()" />
<!--        <svg-icon icon-class="manual" style="margin-right: 0px !important;width: 30px;"class="showlogo" @click="manualRouter()"/>-->
			</div>
		</div>
	</div>
</template>

<script>
	import {mapGetters,mapState} from "vuex";
	import Logo from "./Logo";
	import SidebarItem from "./SidebarItem";
	import variables from "@/assets/styles/variables.scss";
	import Navbar from '../Navbar.vue';
	// import BetterScroll from 'better-scroll';
	// import BScroll from '@better-scroll/core';
	import Swiper from 'swiper'
	export default {
		components: {
			SidebarItem,
			Logo,
			Navbar
		},
		data() {
			return {
				navwidth: '',
				navwidth_page: '',
				showicon: false
			}
		},
		methods: {
			// 转屏/窗口尺寸变化时重新测量导航宽度并刷新 Swiper，保证手机上始终能滑动查看全部菜单
			handleResize: function() {
				if (this.$refs.width && this.$refs.width_page) {
					this.navwidth = this.$refs.width.offsetWidth;
					this.navwidth_page = this.$refs.width_page.offsetWidth;
				}
				if (this.swiperObj) {
					if (typeof this.swiperObj.update === 'function') { this.swiperObj.update(); }
					if (typeof this.swiperObj.onResize === 'function') { this.swiperObj.onResize(); }
				}
			},
			logo_sh: function() {
				this.showicon = !this.showicon;
				this.$emit("top_hide", this.showicon);
			},
      manualRouter:function () {
        this.$router.push("/system/user/manual")
      }
		},
		computed: {
			...mapState(["settings"]),
			...mapGetters(["sidebarRouters", "sidebar"]),
			activeMenu() {
				const route = this.$route;
				let {
					matched,
					meta,
					path
				} = route;
				// if set path, the sidebar will highlight the path you set

				if (typeof(route.matched[0].meta.title) == "undefined") {
					return "homePage";
				} else {
					return route.matched[0].meta.title;
				}
			},
			showLogo() {
				return this.$store.state.settings.sidebarLogo;
			},
			variables() {
				return variables;
			},
			isCollapse() {
				return !this.sidebar.opened;
			},

		},
		created() {

		},
		mounted() {
			this.navwidth = this.$refs.width.offsetWidth;
			this.navwidth_page = this.$refs.width_page.offsetWidth;
			console.log(this.navwidth);
			this.swiperObj = new Swiper('.swiper-container', {
				loop: false,
				slidesPerView: 'auto',
				// 如果需要分页器
				// pagination: '.swiper-pagination',
				// 如果需要前进后退按钮
				nextButton: '.swiper-button-next',
				prevButton: '.swiper-button-prev',
				// 如果需要滚动条
				// scrollbar: '.swiper-scrollbar',
				//如果需要自动切换海报
				// autoplay: {
				//   delay: 1000,//时间 毫秒
				//   disableOnInteraction: false,//用户操作之后是否停止自动轮播默认true
				// },
			});
			window.addEventListener('resize', this.handleResize);

		},
		beforeDestroy() {
			window.removeEventListener('resize', this.handleResize)
		}
	};
</script>
<style>
	.sidebar-container .svg-icon {
		font-size: 26px;
	}
	.sidebar-container .el-menu-item span {
		margin-top: -18px;
		display: inline-block;
	}
	.swiper-button-next, .swiper-button-prev {
		width: 12px !important;
		height: 44px !important;
		background-size: 100% 100% !important;
	}
	.swiper-container {
		width: 100% !important;
	}
	.swiper-slide {
		width: auto !important;
		/*根据内容调整宽度*/
		text-align: center;
		/* border: 1px red solid; */
	}
	.top_scroll {
		height: 82px !important;
	}
	.top_scroll .el-scrollbar__view {
		white-space: nowrap;
		height: 100% !important;
		display: flex !important;
		width: 700px;
		overflow-y: hidden;
		position: relative;
		z-index: 99;
	}
	.top_nav {
		background-color: rgb(28, 129, 217);
		float: left;
		margin-right: 10px !important;
		position: relative;
		border: none;
		width: 1250px;
		display: flex;
		flex-wrap: nowrap;
		overflow: hidden;
		border-right: none !important;
		/* border: 1px solid red; */
	}
	.top_nav::-webkit-scrollbar {
		display: none
	}
	.topRightOut {
		margin-left: 30px;
		width: 320px;
		position: absolute;
		top: 0;
		right: 0;
	}
	.topnavbar {
		height: 50px;
		overflow: hidden;
		width: 256px;
		margin-top: 18px;
		position: relative;
		float: right;
		/*right: 10px;*/
		/* border: 1px red solid; */
	}
	.showlogo {
		float: right;
		font-size: 60px!important;
		margin: -58px 20px 0 0!important;
	}

	@media (max-width: 1860px) {
		.navbar {
			margin-right: 35px!important;
		}
		.top_nav {
			width: 1150px;
		}
		.topRightOut {
		    margin-left: 10px;
		    width: 280px;
		}
		.showlogo {
			margin: -58px 5px 0 0!important;
		}
	}
	@media (max-width: 1720px) {
		.top_nav {
		    width: 1030px;
		}
	}
	@media (max-width: 1680px) {
		.top_nav {
		    width: 1020px;
		}
	}
	@media (max-width: 1590px) {
		.top_nav {
		    width: 860px;
		}
	}
	@media (max-width: 1480px) {
		.top_nav {
		    width: 860px;
		}
	}
	@media (max-width: 1480px) {
		.top_nav {
		    width: 770px;
		}
	}
	@media (max-width: 1350px) {
		.top_nav {
		    width: 660px;
		}
	}
	@media (max-width: 1250px) {
		.top_nav {
		    width: 560px;
		}
	}
	@media (max-width: 1150px) {
		.top_nav {
		    width: 460px;
		}
	}
	@media (max-width: 1050px) {
		.top_nav {
			width: 380px;
		}
	}

	/* 手机端（<992px）：收窄Logo与右侧用户区，一级菜单通过手指左右滑动查看全部 */
	@media (max-width: 991px) {
		.logo_mini_box {
			width: 120px !important;
			height: 34px !important;
			left: 10px !important;
			top: 24px !important;
		}

		.top_nav {
			width: calc(100vw - 325px);
			margin-left: 140px !important;
		}

		.swiper-button-prev {
			left: 124px !important;
		}

		/* 顶部菜单图标与文字整体缩小 */
		.sidebar-container .svg-icon {
			font-size: 20px;
		}

		.sidebar-container .el-menu-item span {
			font-size: 12px;
		}

		.topRightOut {
			width: 175px;
		}

		.topnavbar {
			width: 175px;
			margin-top: 14px;
		}

		.navbar {
			margin-right: 0px !important;
		}

		/* 横屏高度有限，隐藏"大Logo横幅"切换按钮，保持紧凑头部 */
		.showlogo {
			display: none;
		}
	}
</style>
